/* eslint-disable */

import objectPath from "object-path";
import merge from "deepmerge";
import {Mutations} from "@/store/enums/store.enums";
import {Mutation, Module, VuexModule} from "vuex-module-decorators";

import layoutConfig from "@/core/config/layoutConfig";
import layoutConfigInterface from "@/core/config/layoutConfig.interface";

interface StoreInfo {
    config: layoutConfigInterface;
    initial: layoutConfigInterface;
}

@Module
export default class configModule extends VuexModule implements StoreInfo {
    config: layoutConfigInterface = layoutConfig;
    initial: layoutConfigInterface = layoutConfig;

    /**
     * Get config from layout config
     * @returns {function(path, defaultValue): *}
     */
    get layoutConfig() {
        return (path, defaultValue) => {
            return objectPath.get(this.config, path, defaultValue);
        };
    }

    @Mutation
    [Mutations.SET_LAYOUT_CONFIG](payload: layoutConfigInterface): void {
        this.config = payload;
    }

    @Mutation
    [Mutations.RESET_LAYOUT_CONFIG]() {
        this.config = Object.assign({}, this.initial);
    }

    @Mutation
    [Mutations.OVERRIDE_LAYOUT_CONFIG](): void {
        this.config = this.initial = Object.assign(
            {},
            this.initial,
            JSON.parse(window.localStorage.getItem("config") || "{}")
        );
    }

    @Mutation
    [Mutations.OVERRIDE_PAGE_LAYOUT_CONFIG](payload: layoutConfigInterface): void {
        this.config = merge(this.config, payload);
    }
}
